import { motion, Variants } from "framer-motion";

interface AnimatedProgressCircleProps {
  /** Progress of the loader, between 0 and 100, required */
  progress: number;
  color?: string;
  bgColor?: string;
  /** Horizontal and vertical size in pixels, default 12 */
  size?: number;
  /** Width of the circle stroke in pixels, default 2 */
  thickness?: number;
  animationProp?: Variants;
}

export const AnimatedProgressCircle = (props: AnimatedProgressCircleProps) => {
  const {
    animationProp,
    progress,
    color = "#0D5772",
    bgColor = "lightgrey",
    size = 12,
    thickness = 2
  } = props;

  const normalizedRadius = size - thickness * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const offset =
    circumference -
    (Math.min(Math.max(progress, 0), 100) / 100) * circumference;
  const fill = "transparent";

  const progressCircleTest = {
    visible: { strokeDashoffset: offset },
    hidden: { strokeDashoffset: 200 }
  };

  return (
    <motion.svg height={size * 2} width={size * 2} {...animationProp}>
      <circle
        stroke={bgColor}
        fill={fill}
        strokeWidth={thickness}
        r={normalizedRadius}
        cx={size}
        cy={size}
      />
      <motion.circle
        variants={progressCircleTest}
        className="origin-half"
        stroke={color}
        fill={fill}
        strokeWidth={thickness}
        strokeDasharray={`${circumference} ${circumference}`}
        r={normalizedRadius}
        cx={size}
        cy={size}
      />
    </motion.svg>
  );
};
